import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  TeamOutlined,
  FunnelPlotOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  ArrowRightOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByKey: Record<string, JSX.Element> = {
  lead: <TeamOutlined />,
  nurture: <FunnelPlotOutlined />,
  quote: <FileTextOutlined />,
  close: <ShoppingCartOutlined />,
};

interface WorkflowFlowProps {
  className?: string;
  variant?: "default" | "compact";
}

const WorkflowFlow = ({ className = "", variant = "default" }: WorkflowFlowProps) => {
  const { t } = useTranslation("crm");
  const isCompact = variant === "compact";

  const steps = useMemo(() => {
    const raw = t("workflow.steps", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ key: string; label: string }>;
  }, [t]);

  return (
    <div
      className={[
        "dev-crm-workflow-grid",
        isCompact ? "dev-crm-workflow--compact" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="dev-crm-workflow-track">
        {steps.map((step, idx) => (
          <Fragment key={step.key}>
            {isCompact ? (
              <div className="dev-crm-step-item">
                <div className={`dev-crm-step-card dev-crm-step-card--${step.key}`}>
                  <div className="dev-crm-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                </div>
                <div className="dev-crm-step-title">{step.label}</div>
              </div>
            ) : (
              <div className={`dev-crm-step-card dev-crm-step-card--${step.key}`}>
                <div className="dev-crm-step-icon">{iconByKey[step.key] ?? <RightOutlined />}</div>
                <div className="dev-crm-step-title">{step.label}</div>
              </div>
            )}
            {idx < steps.length - 1 && (
              <div className="dev-crm-step-connector" aria-hidden>
                <ArrowRightOutlined />
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowFlow;
